import React from 'react';
import { FlatIcon } from 'components/atoms/Icons/FlatIcon';
import { Icon } from 'components/atoms/Icons';
import useStyle from './iconLabel.style';
import { classNames } from 'helpers/style/classNames';
import Label from '../../Label';

interface IconLabelProps {
  icon: Icon;
  label: string;
  backgroundColor?: string;
  withoutMargin?: boolean;
}

export const IconLabel = ({
  icon,
  label,
  backgroundColor,
  withoutMargin
}: IconLabelProps) => {
  const classes = useStyle();

  return (
    <div
      className={classNames([classes.root], {
        condition: withoutMargin,
        classe: classes.noMargin
      })}
    >
      <FlatIcon icon={icon} />
      <Label text={label} backgroundColor={backgroundColor} />
    </div>
  );
};
